import * as React from 'react';
import styled, { css } from 'styled-components';
import ReactInputMask from 'react-input-mask';
import { omitProps } from "../helpers";

export const InputWrapper = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__InputWrapper", componentId: "sc-1x9cz16-0" })(["position:relative;color:", ";"],

(props) => props.theme.colors.Foreground);


export const StyledInput = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__StyledInput", componentId: "sc-1x9cz16-1" })(["display:flex;border-bottom:2px solid ", ";"],

(props) => props.theme.colors['Level 4']);


export const InputLabel = /*#__PURE__*/styled.label.withConfig({ displayName: "styles__InputLabel", componentId: "sc-1x9cz16-2" })(["position:absolute;top:", ";left:0;height:12px;color:", ";white-space:nowrap;pointer-events:none;user-select:none;transition:all 0.2s;transition-timing-function:cubic-bezier(0.4,0,0.2,1);", ""],

({ active }) => active ? '0px' : '18px',


(props) => props.theme.colors['Level 4'],






(props) => css(props.theme.typography.SmallCapsHeadline));


const InputComponent = ({ isMask, ...props }) => {
  if (isMask) {
    return /*#__PURE__*/React.createElement(ReactInputMask, props);
  }

  return /*#__PURE__*/React.createElement("input", props);
};

export const InputField = /*#__PURE__*/styled(omitProps('withIconRight', 'theme')(InputComponent)).withConfig({ displayName: "styles__InputField", componentId: "sc-1x9cz16-3" })(["padding:16px 0 4px;width:100%;line-height:18px;color:inherit;border:0;outline:transparent;background-color:transparent;box-sizing:border-box;", " &:focus ~ ", "{top:0px;}&:disabled{color:", ";}"],









(props) => css(props.theme.typography.Paragraph),

InputLabel,




(props) => props.theme.colors['Level 3']);



export const InputIcon = /*#__PURE__*/styled.span.withConfig({ displayName: "styles__InputIcon", componentId: "sc-1x9cz16-4" })(["align-self:flex-end;color:", ";"],

(props) => props.theme.colors['Level 4']);


const TextBlockUnderInput = /*#__PURE__*/styled.span.withConfig({ displayName: "styles__TextBlockUnderInput", componentId: "sc-1x9cz16-5" })(["display:inline-block;margin-top:", ";font-style:italic;font-weight:500;font-size:12px;line-height:17.28px;"],

(props) => props.theme.spacers.M);





export const InputError = /*#__PURE__*/styled(TextBlockUnderInput).withConfig({ displayName: "styles__InputError", componentId: "sc-1x9cz16-6" })(["color:#f44336;"]);



export const InputHelperText = /*#__PURE__*/styled(TextBlockUnderInput).withConfig({ displayName: "styles__InputHelperText", componentId: "sc-1x9cz16-7" })(["color:", ";"],
(props) => props.theme.colors['Level 4']);